// Opções do Assistente de IA, usadas pela lista e pelo modal.

export const MODELS = [
  { value: "gpt-4o-mini", label: "GPT-4o Mini", hint: "Rápido e econômico. Recomendado." },
  { value: "gpt-4o", label: "GPT-4o", hint: "Mais inteligente, para respostas complexas." },
  { value: "gpt-4-turbo", label: "GPT-4 Turbo", hint: "Versão anterior do GPT-4." },
  { value: "gpt-3.5-turbo", label: "GPT-3.5 Turbo", hint: "Modelo mais antigo, menor custo." },
];

export const modelLabel = (value) =>
  (MODELS.find((m) => m.value === value) || {}).label || value || "GPT-4o Mini";

// "texto" = responde em texto; as demais são vozes do Azure em português.
export const TEXT_VOICE = "texto";

export const VOICES = [
  { value: "pt-BR-FranciscaNeural", label: "Francisca" },
  { value: "pt-BR-AntonioNeural", label: "Antônio" },
  { value: "pt-BR-BrendaNeural", label: "Brenda" },
  { value: "pt-BR-DonatoNeural", label: "Donato" },
  { value: "pt-BR-ElzaNeural", label: "Elza" },
  { value: "pt-BR-FabioNeural", label: "Fábio" },
  { value: "pt-BR-GiovannaNeural", label: "Giovanna" },
  { value: "pt-BR-HumbertoNeural", label: "Humberto" },
  { value: "pt-BR-JulioNeural", label: "Julio" },
  { value: "pt-BR-LeilaNeural", label: "Leila" },
  { value: "pt-BR-LeticiaNeural", label: "Letícia" },
  { value: "pt-BR-ManuelaNeural", label: "Manuela" },
  { value: "pt-BR-NicolauNeural", label: "Nicolau" },
  { value: "pt-BR-ValerioNeural", label: "Valério" },
  { value: "pt-BR-YaraNeural", label: "Yara" },
];

export const isVoice = (voice) => Boolean(voice) && voice !== TEXT_VOICE;

export const voiceLabel = (value) =>
  (VOICES.find((v) => v.value === value) || {}).label || value;

export const PROMPT_MAX_CHARS = 20000;
